import(/* webpackMode: "eager" */ "/vercel/path0/client/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/client/node_modules/next/font/google/target.css?{\"path\":\"src/app/page.js\",\"import\":\"Fraunces\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"500\",\"600\",\"700\"],\"style\":[\"normal\",\"italic\"],\"variable\":\"--font-display\",\"display\":\"swap\"}],\"variableName\":\"display\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/client/src/components/landing/landing.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/client/src/components/landing/ModuleShowcase.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/client/src/components/landing/ProductTour.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/client/src/components/landing/Reveal.js");
;
import(/* webpackMode: "eager", webpackExports: ["Shot","BrowserFrame","PhoneFrame"] */ "/vercel/path0/client/src/components/landing/Shot.js");
